import axios from 'axios'
import { useState, useEffect } from 'react'
import { MagnoliaReferenceImage } from 'src/utils/magnolia'

interface IBannerData {
  bannerDesktop?: Partial<MagnoliaReferenceImage>
  bannerMobile?: Partial<MagnoliaReferenceImage>
  slugDesktop?: string
  slugMobile?: string
  name?: string
}

export const useGetMagnoliaBanner = codename => {
  const [dataBanner, setDataBanner] = useState<IBannerData[]>([])
  const [isBannerLoading, setIsBannerLoading] = useState(true)

  const getBanner = async () => {
    try {
      const { data, status } = await axios.get(
        `${process.env.BASE_MAGNOLIA_REST_URL}/delivery/banner/${codename}/@nodes`
      )
      if (status === 200 && data.length > 0) {
        setDataBanner(data)
        setIsBannerLoading(false)
      } else {
        setIsBannerLoading(true)
      }
    } catch (error) {
      console.error('Error fetching banner:', error)
      setIsBannerLoading(true)
    }
  }

  useEffect(() => {
    getBanner()
  }, [codename])

  return { dataBanner, isBannerLoading }
}
